/**
 * @file: SidebarItemBadge.tsx
 * @copyright: (c) 2019-2020 sichuan zhichetech co., ltd.
 */

import { TrialBadge } from '@euler/components/entitlements/TrialBadge';
import { useAiTrialEndsAt } from '@euler/functions/entitlements/useAiTrialEndsAt';
import { memo } from 'react';
import type { SidebarItem } from './AppSidebar';

/**
 * The `试用中` pill after a menu item on a trial. 知车AI's shows while the
 * store is trying AI (any feature that spends AI credits on a trial), on
 * the workshop line only.
 */
export const SidebarItemBadge = memo(({ item }: { item: SidebarItem }) => {
  const aiTrialEndsAt = useAiTrialEndsAt();
  return (
    <TrialBadge
      trialEndsAt={item.aiTrial ? aiTrialEndsAt : item.trialEndsAt ?? null}
    />
  );
});
